import { Route, Redirect } from 'react-router-dom'
import Secured from 'src/components/security/Secured'
import { AddressDetail } from './basic-queries/pages/Address/AddressDetail/AddressDetail'
import { AddressInfo } from './basic-queries/pages/Address/AddressInfo/AddressInfo'
import { BasicQueries } from './basic-queries/pages/BasicQueries/BasicQueries'
import { BatchDetail } from './basic-queries/pages/batchDetail/BatchDetail'
import { BatchInfo } from './basic-queries/pages/BatchInfo/BatchInfo'
import { ProductBatch } from './basic-queries/pages/ProductInfo/ProductInfo/ProductInfo'
import { ProductBatchDetails } from './basic-queries/pages/ProductInfo/ProductInfoDetails/ProductDetails'
import StockAddressingInBatch from './stock-addressing-in-batch/pages/StockAddressingInBatchPage'
import AdjustmentInBatchPage from './stock-adjustment-in-batch/pages/AdjustmentInBatchPage'
import PendingAdjustmentPage from './stock-adjustment-in-batch/pages/PendingAdjustment'
import PendingAdjustmentDetailsPage from './stock-adjustment-in-batch/pages/PendingAjustmentDetailsPage'
import StockListPage from './stock-list/pages/StockListPage'
import ProductPage from './stock-management/pages/ProductPage'
import MovementsPage from './stock-movements/pages/MovementsPage'
import TaxCouponEntryPage from './tax-coupon/pages/TaxCouponEntryPage'
import TaxCouponFinishPage from './tax-coupon/pages/TaxCouponFinishPage'
import DockManagement from 'src/features/dock-management/pages/DockManagement/DockManagement'
import RestockingGenerateLists from './restocking/pages/GenerateLists/RestockingGenerateLists'
import InventoryLists from './inventory/pages/InventoryLists/InventoryLists'
import InventoryExecute from './inventory/pages/InventoryExecute/InventoryExecute'
import ShedManagementLocations from './shed-management/pages/ShedManagementLocations/ShedManagementLocations'
import ShedManagementProducts from './shed-management/pages/ShedManagementProducts/ShedManagementProducts'
import RestockListManagement from './restocking/pages/RestockListManagement/RestockListManagement'
import ProductPagesManagement from './restocking/pages/ProductPagesManagement/ProductPagesManagement'
import BadgePage from './restocking/pages/RestockingWebApp/BadgePage/BadgePage'
import ForkliftQuestionPage from './restocking/pages/RestockingWebApp/ForkliftQuestionPage/ForkliftQuestionPage'
import ListSelectionPage from './restocking/pages/RestockingWebApp/ListSelectionPage/ListSelectionPage'
import CollectAddressPage from './restocking/pages/RestockingWebApp/CollectAddressPage/CollectAddressPage'
import CollectProductPage from './restocking/pages/RestockingWebApp/CollectProductPage/CollectProductPage'
import CollectBatchPage from './restocking/pages/RestockingWebApp/CollectBatchPage/CollectBatchPage'
import RestockAddressPage from './restocking/pages/RestockingWebApp/RestockAddressPage/RestockAddressPage'
import RestockProductPage from './restocking/pages/RestockingWebApp/RestockProductPage/RestockProductPage'
import FinishedRestockingPage from './restocking/pages/RestockingWebApp/FinishedRestockingPage/FinishedRestockingPage'
import FlvReleasePage from './stock-management/pages/FlvReleasePage/FlvReleasePage'
import { RestockingPageDetails } from './restocking/pages/RestockingPageDetails/RestockingPageDetails'
import CreateSwapOrReturn from './swap-or-return/pages/CreateSwapOrReturn/CreateSwapOrReturn'
import ManageSwapOrReturn from './swap-or-return/pages/ManageSwapOrReturn'
import ResolveSwapOrReturn from './swap-or-return/pages/ResolveSwapOrReturn'
import { PrintInvoicesPage, PrintInvoicePageModeEnum } from './swap-or-return/pages/PrintInvoicesPage/PrintInvoicesPage'
import PrintersManagementPage from './settings/printers-management/pages/PrintersManagementPage/PrintersManagementPage'
import TransfersManagement from './transfers/pages/TransfersManagement/TransfersManagement'
import TransfersManagementPages from './transfers/pages/TransfersManagementPages/TransfersManagementPages'
import RestockEntryCollectAddressPage from './restocking/pages/RestockingWebApp/RestockCagePage/RestockEntryCollectAddressPage'
import { TransferPageDetails } from './transfers/pages/TransferPageDetails/TransferPageDetails'
import ValidateBadge from './transfers/pages/TransferReceive/ValidateBadge/ValidateBadge'
import ReceiveStart from './transfers/pages/TransferReceive/ReceiveStart/ReceiveStart'
import ReceiveItem from './transfers/pages/TransferReceive/ReceiveItem/ReceiveItem'
import ReceiveWaiting from './transfers/pages/TransferReceive/ReceiveWaiting/ReceiveWaiting'
import DivergenceListPage from './divergence-demands/pages/DivergenceListPage/DivergenceListPage'
import DivergenceBadgePage from './divergence-demands/pages/DivergenceBadgePage/DivergenceBadgePage'
import DivergenceProductPage from './divergence-demands/pages/DivergenceProductPage/DivergenceProductPage'
import AddLocations from './shed-management/pages/AddLocations/AddLocations'
import CagesManagement from './transfers/pages/CagesManagement/CagesManagement'
import { CageDetails } from './transfers/pages/CageDetails/CageDetails'
import { RestockingLabelPrint } from './restocking/pages/Label/RestockingLabelPrint'

export default (
  <>
    <Route path='/stock-managment/list'>
      <Secured claim='main-stock:stock'>
        <StockListPage />
      </Secured>
    </Route>
    <Route
      path='/stock-managment/product/:fulfillmentCenterId/:modelId'
    >
      <Secured claim='main-stock:stock'>
        <ProductPage />
      </Secured>
    </Route>
    <Route path='/stock-managment/movements'>
      <Secured claim='main-stock:stock'>
        <MovementsPage />
      </Secured>
    </Route>
    <Route path='/stock-managment/stock-addressing-in-batch'>
      <Secured claim='main-stock:stock'>
        <StockAddressingInBatch />
      </Secured>
    </Route>

    <Route path='/stock-managment/update-flv-availability'>
      <Secured claim='main-stock:stock'>
        <FlvReleasePage />
      </Secured>
    </Route>

    <Route path='/adjustments/adjustment-in-batch'>
      <Secured claim='main-stock:stock'>
        <AdjustmentInBatchPage />
      </Secured>
    </Route>
    <Route exact path='/adjustments/pending-adjustments'>
      <Secured claim='main-stock:stock'>
        <PendingAdjustmentPage />
      </Secured>
    </Route>
    <Route path='/adjustments/pending-adjustments/:adjustmentId'>
      <Secured claim='main-stock:stock'>
        <PendingAdjustmentDetailsPage />
      </Secured>
    </Route>

    <Route path='/tax-coupon/entry'>
      <Secured claim='home:receivement'>
        <TaxCouponEntryPage />
      </Secured>
    </Route>

    <Route path='/tax-coupon/finish'>
      <Secured claim='home:receivement'>
        <TaxCouponFinishPage />
      </Secured>
    </Route>

    <Route path='/basic-queries' exact>
      <Secured claim='home:basic_queries'>
        <BasicQueries />
      </Secured >
    </Route>

    <Route path='/basic-queries/batch-info' exact>
      <Secured claim='basic_queries:batch'>
        <BatchInfo/>
      </Secured >

    </Route>

    <Route path='/basic-queries/batch-info/:batch/address/:address'>
      <Secured claim='basic_queries:address_detail'>
        <BatchDetail/>
      </Secured >
    </Route>

    <Route path='/basic-queries/address-info' exact>
      <Secured claim='basic_queries:address_products'>
        <AddressInfo />
      </Secured >
    </Route>

    <Route path='/basic-queries/address-info/:address/product/:productCode' exact>
      <Secured claim='basic_queries:address_detail'>
        <AddressDetail />
      </Secured >
    </Route>

    <Route path='/basic-queries/product-info' exact>
      <Secured claim='basic_queries:product'>
        <ProductBatch/>
      </Secured >
    </Route>

    <Route path='/basic-queries/product-info/:barcode/address/:address'>
      <Secured claim='basic_queries:address_detail'>
        <ProductBatchDetails/>
      </Secured >
    </Route>

    <Route path='/dock-management' exact>
      <Secured claim='home:dock_management'>
        <DockManagement />
      </Secured>
    </Route>

    <Route path='/transfers/generate' exact>
      <Secured claim='home:restocking'>
        <RestockingGenerateLists forTransfer />
      </Secured>
    </Route>

    <Route path='/transfers/manage' exact>
      <Secured claim='home:restocking'>
        <TransfersManagement />
      </Secured>
    </Route>

    <Route path='/transfers/manage/:idList/pages' exact>
      <Secured claim='home:restocking'>
        <TransfersManagementPages />
      </Secured>
    </Route>

    <Route path='/transfers/manage/page/:idPage/details' exact>
      <Secured claim='home:restocking'>
        <TransferPageDetails />
      </Secured>
    </Route>

    <Route path='/transfers/cages/manage' exact>
      <Secured claim='transfer:cage:manage'>
        <CagesManagement />
      </Secured>
    </Route>

    <Route path='/transfers/cages/manage/cage/:idCage/details' exact>
      <Secured claim='transfer:cage:manage'>
        <CageDetails />
      </Secured>
    </Route>

    <Route path='/transfers/receive' exact>
      <Secured claim='movement:movement'>
        <ValidateBadge />
      </Secured>
    </Route>

    <Route path='/transfers/receive/start' exact>
      <Secured claim='movement:movement'>
        <ReceiveStart />
      </Secured>
    </Route>

    <Route path='/transfers/receive/waiting' exact>
      <Secured claim='movement:movement'>
        <ReceiveWaiting />
      </Secured>
    </Route>

    <Route path='/transfers/receive/item' exact>
      <Secured claim='movement:movement'>
        <ReceiveItem />
      </Secured>
    </Route>

    <Route path='/restocking/generate' exact>
      <Secured claim='home:restocking'>
        <RestockingGenerateLists />
      </Secured>
    </Route>

    <Route path='/restocking/divergence' exact>
      <Secured claim='restocking:manage'>
        <DivergenceListPage />
      </Secured>
    </Route>

    <Route path='/restocking/divergence/badge' exact>
      <Secured claim='home:restocking'>
        <DivergenceBadgePage />
      </Secured>
    </Route>

    <Route path='/restocking/divergence/address' exact>
      <Secured claim='home:restocking'>
        <Redirect to='/restocking/divergence/product' />
      </Secured>
    </Route>

    <Route path='/restocking/divergence/product' exact>
      <Secured claim='home:restocking'>
        <DivergenceProductPage />
      </Secured>
    </Route>

    <Route path='/restocking/manage' exact>
      <Secured claim='home:restocking'>
        <RestockListManagement />
      </Secured>
    </Route>

    <Route path='/restocking/manage/pages/:idList' exact>
      <Secured claim='home:restocking'>
        <ProductPagesManagement />
      </Secured>
    </Route>

    <Route path='/restocking/manage/page/:idPage/details' exact>
      <Secured claim='home:restocking'>
        <RestockingPageDetails />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/badge' exact>
      <Secured claim='restocking:start_finish'>
        <BadgePage />
      </Secured>
    </Route>

    <Route path='/restocking/label/print' exact>
      <Secured claim='home:restocking'>
        <RestockingLabelPrint />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/forklift-question' exact>
      <Secured claim='restocking:start_finish'>
        <ForkliftQuestionPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/list-selection' exact>
      <Secured claim='restocking:start_finish'>
        <ListSelectionPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/entry-collect-address' exact>
      <Secured claim='restocking:start_finish'>
        <RestockEntryCollectAddressPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/collect-address' exact>
      <Secured claim='restocking:start_finish'>
        <CollectAddressPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/collect-product' exact>
      <Secured claim='restocking:start_finish'>
        <CollectProductPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/collect-batch' exact>
      <Secured claim='restocking:start_finish'>
        <CollectBatchPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/restock-address' exact>
      <Secured claim='restocking:start_finish'>
        <RestockAddressPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/restock-product' exact>
      <Secured claim='restocking:start_finish'>
        <RestockProductPage />
      </Secured>
    </Route>

    <Route path='/restocking/webapp/restock-finished' exact>
      <Secured claim='restocking:start_finish'>
        <FinishedRestockingPage />
      </Secured>
    </Route>

    <Route path='/inventory/list' exact>
      <Secured claim='home:inventory'>
        <InventoryLists />
      </Secured>
    </Route>

    <Route path='/inventory/execute' exact>
      <Secured claim='home:inventory'>
        <InventoryExecute />
      </Secured>
    </Route>

    <Route path='/shed-management/locations' exact>
      <Secured claim='home:warehouse_attributes'>
        <ShedManagementLocations />
      </Secured>
    </Route>

    <Route path='/shed-management/products' exact>
      <Secured claim='home:warehouse_attributes'>
        <ShedManagementProducts />
      </Secured>
    </Route>

    <Route path='/shed-management/add-locations' exact>
      <Secured claim='warehouse:addresses:create'>
        <AddLocations />
      </Secured>
    </Route>

    <Route path='/swap-or-return/create/:idRequest?' exact>
      <Secured claim='user:dummie'>
        <CreateSwapOrReturn />
      </Secured>
    </Route>

    <Route path='/swap-or-return/manage' exact>
      <Secured claim='user:dummie'>
        <ManageSwapOrReturn />
      </Secured>
    </Route>

    <Route path='/swap-or-return/resolve' exact>
      <Secured claim='user:dummie'>
        <ResolveSwapOrReturn />
      </Secured>
    </Route>

    <Route path='/invoices/release/swap-or-return' exact>
      <Secured claim='user:dummie'>
        <PrintInvoicesPage mode={PrintInvoicePageModeEnum.PENDINGS} />
      </Secured>
    </Route>

    <Route path='/invoices/release/receivement' exact>
      <Secured claim='user:dummie'>
        <PrintInvoicesPage mode={PrintInvoicePageModeEnum.RECEIVEMENT} />
      </Secured>
    </Route>

    <Route path='/settings/printers-management' exact>
      <Secured claim='user:dummie'>
        <PrintersManagementPage />
      </Secured>
    </Route>
  </>
)
